const calculateSubtotal = (quantity, price) => {
    return Number(price ?? 0) * Number(quantity ?? 0);
};

const calculatePackageTotal = items => {
    return items.reduce((total, item) => {
        return total + calculateSubtotal(item.quantity, item.price);
    }, 0);
};

export function calculateFormTotals(form) {
    const {
        quantity,
        value,
        personalMessage,
        giftWrap,
        packaging,
        upsell
    } = form;
    let subtotal = 0;

    if (value) {
        subtotal += quantity * value;
    }

    if (personalMessage?.checked && quantity) {
        subtotal += calculateSubtotal(quantity, personalMessage.price);
    }

    if (giftWrap?.enabled && giftWrap.price && quantity) {
        subtotal += calculateSubtotal(quantity, giftWrap.price);
    }

    if (packaging?.items?.length > 0) {
        subtotal += calculatePackageTotal(packaging.items);
    }

    if (upsell?.items?.length > 0) {
        subtotal += calculatePackageTotal(upsell.items);
    }

    return {
        quantity: quantity ?? 0,
        subtotal,
        value
    };
}

function generatePackagingUpsellOptions(itemOptions, items) {
    const formattedItems = items
        .filter(pack => pack.quantity > 0)
        .map(itemOption => {
            const { id, quantity, rowTotal } = itemOption;
            const { title, price, sku } = itemOption?.variant;

            return {
                id,
                title,
                price: Number(price),
                quantity,
                sku,
                rowTotal
            };
        });
    return itemOptions.concat(formattedItems);
}

function generateGiftwrapPersonalMessageOptions(
    itemOptions,
    providedItem,
    title
) {
    const { price } = providedItem.giftwrap;
    const formattedOption = [
        {
            quantity: providedItem.quantity,
            title,
            price: Number(price),
            rowTotal: Number(price) * Number(providedItem?.quantity)
        }
    ];
    return itemOptions.concat(formattedOption);
}

export function parseItemOptions(item) {
    let itemOptions = [];
    itemOptions = [
        ...itemOptions,
        {
            quantity: item?.quantity,
            title: item?.variant?.title,
            price: item?.variant?.price,
            rowTotal: item?.variant?.price * item?.quantity
        }
    ];

    if (item.giftwrap && item.giftwrap.enabled) {
        itemOptions = generateGiftwrapPersonalMessageOptions(
            itemOptions,
            item,
            "Inpakservice"
        );
    }

    if (
        item.personalMessage &&
        item.personalMessage.enabled &&
        item.message.length > 0
    ) {
        itemOptions = generateGiftwrapPersonalMessageOptions(
            itemOptions,
            item,
            "Persoonlijk bericht"
        );
    }

    if (item.packaging && item.packaging.length > 0) {
        itemOptions = generatePackagingUpsellOptions(
            itemOptions,
            item.packaging
        );
    }

    if (item.upsell && item.upsell.length > 0) {
        itemOptions = generatePackagingUpsellOptions(itemOptions, item.upsell);
    }
    return itemOptions;
}
